import { render, staticRenderFns } from "./rewrite.vue?vue&type=template&id=5ab39598&scoped=true"
import script from "./rewrite.vue?vue&type=script&lang=js"
export * from "./rewrite.vue?vue&type=script&lang=js"
import style0 from "./rewrite.vue?vue&type=style&index=0&id=5ab39598&prod&lang=less"
import style1 from "./rewrite.vue?vue&type=style&index=1&id=5ab39598&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab39598",
  null
  
)

export default component.exports